export const ModelEditorialSection = ({ eyebrow, title, text, image, imageAlt, reverse = false, testid }) => (
  <section data-testid={testid} className="bg-white py-20 sm:py-28">
    <div className={`mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-16 ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>
      <div className="overflow-hidden bg-cream"><div className="aspect-[4/3]"><img src={image} alt={imageAlt} loading="lazy" className="h-full w-full object-cover object-center" /></div></div>
      <div className="max-w-xl">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-cognac">{eyebrow}</p>
        <h2 className="mt-4 font-display text-4xl font-medium leading-tight text-navy sm:text-5xl">{title}</h2>
        <p className="mt-6 text-sm leading-relaxed text-stone-600 sm:text-base">{text}</p>
      </div>
    </div>
  </section>
);